const globalUserData = {
  userData: {}
};
module.exports = globalUserData;
